const chineseRegex = /[\u4e00-\u9fa5]/;
const wordAndNonWordRegex = /\b\w+\b|[^\w]+/g;
export type textContent = {
  type: "text";
  value: Array<string>;
};
export type imgContent = {
  type: "img";
  value: Array<string>;
};
export type linkContent = {
  type: "link";
  value: Array<string>;
};
export type streamContent = textContent | imgContent | linkContent;
// 打字机队列
export class Typewriter {
  private queue: Array<streamContent> = [];
  private consuming = false;
  private timer: any;
  constructor(
    private onConsume: (
      item: { type: "text" | "img" | "link"; value: string },
      isCompleted: boolean
    ) => void
  ) {}
  // 输出速度动态控制
  dynamicSpeed() {
    let length = 0;
    this.queue.forEach((item: streamContent) => {
      length += item.value.length;
    });
    const speed = 500 / length;
    if (speed > 50) {
      return 50;
    } else {
      return speed;
    }
  }
  // 添加字符串到队列
  add(item: { type: "text" | "img" | "link"; value: string }) {
    if (!item || !item.value) return;
    switch (item.type) {
      case "text":
        if (chineseRegex.test(item.value)) {
          const newValueArray = item.value.split("");
          this.queue.push({ type: item.type, value: newValueArray });
        } else {
          const newValueArray = item.value.match(wordAndNonWordRegex) || item.value.split("");
          this.queue.push({ type: item.type, value: newValueArray });
        }
        break;
      case "img":
        this.queue.push({
          type: item.type,
          value: [item.value],
        });
        break;
      case "link":
        this.queue.push({
          type: item.type,
          value: [item.value],
        });
        break;
    }
  }
  // 消费
  consume() {
    if (this.queue.length > 0) {
      let firstConsumeItem = {
        type: this.queue[0].type,
        value: this.queue[0].value?.[0] || "",
      };
      if (this.queue[0].value.length) {
        this.queue[0].value.shift();
      } else {
        this.queue.shift();
      }
      firstConsumeItem && this.onConsume(firstConsumeItem, this.queue.length ? false : true);
    }
  }
  // 消费下一个
  next() {
    this.consume();
    // 根据队列中字符的数量来设置消耗每一帧的速度，用定时器消耗
    this.timer = setTimeout(() => {
      this.consume();
      if (this.consuming) {
        this.next();
      }
    }, this.dynamicSpeed());
  }
  // 开始消费队列
  start() {
    this.consuming = true;
    this.next();
  }
  // 结束消费队列
  done() {
    this.consuming = false;
    clearTimeout(this.timer);
    // 把queue中剩下的字符一次性消费
    this.queue.forEach((item: streamContent) => {
      item.value.forEach((valueItem: string) => {
        this.onConsume({ type: item.type, value: valueItem }, this.queue.length ? false : true);
      });
    });
    this.queue = [];
  }
}
